import { render, staticRenderFns } from "./File.vue?vue&type=template&id=3e9299ea&scoped=true&"
import script from "./File.vue?vue&type=script&lang=js&"
export * from "./File.vue?vue&type=script&lang=js&"
import style0 from "./File.vue?vue&type=style&index=0&id=3e9299ea&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e9299ea",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3e9299ea')) {
      api.createRecord('3e9299ea', component.options)
    } else {
      api.reload('3e9299ea', component.options)
    }
    module.hot.accept("./File.vue?vue&type=template&id=3e9299ea&scoped=true&", function () {
      api.rerender('3e9299ea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/javascript/dashboard/components/widgets/conversation/bubble/File.vue"
export default component.exports